import { render, staticRenderFns } from "./Prefeitura.vue?vue&type=template&id=3f4ef8d3&"
import script from "./Prefeitura.vue?vue&type=script&lang=js&"
export * from "./Prefeitura.vue?vue&type=script&lang=js&"
import style0 from "./Prefeitura.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports